import axios from 'axios';
import { API_BASE_URL } from '../utils/constants';

// 创建axios实例
// 如果API_BASE_URL为空，使用相对路径（通过proxy或nginx代理）
const client = axios.create({
  baseURL: API_BASE_URL || '',  // 空字符串表示使用相对路径
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
client.interceptors.request.use(
  (config) => {
    // FormData 必须由浏览器自动带 multipart boundary，不能沿用默认 application/json
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    // 自动添加Token
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
client.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    // 处理401未授权错误
    if (error.response?.status === 401) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('username');
      window.location.href = '/login';
    }
    const message = error.response?.data?.detail || error.message || '请求失败';
    return Promise.reject(new Error(message));
  }
);

// ========== Pages API ==========
export const pagesAPI = {
  getAll: () => client.get('/api/pages'),
  getContent: (pageCode) => client.get(`/api/pages/${pageCode}/content`)
};

// ========== Modules API ==========
export const modulesAPI = {
  getAll: (params) => client.get('/api/modules', { params }),
  getOne: (id) => client.get(`/api/modules/${id}`),
  create: (data) => client.post('/api/modules', data),
  update: (id, data) => client.put(`/api/modules/${id}`, data),
  delete: (id) => client.delete(`/api/modules/${id}`)
};

// ========== Fields API ==========
export const fieldsAPI = {
  getAll: (params) => client.get('/api/fields', { params }),
  getOne: (id) => client.get(`/api/fields/${id}`),
  create: (data) => client.post('/api/fields', data),
  update: (id, data) => client.put(`/api/fields/${id}`, data),
  delete: (id) => client.delete(`/api/fields/${id}`)
};

// ========== Upload API ==========
export const uploadAPI = {
  /** @param {File|Blob} file */
  uploadCover: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return client.post('/api/upload/cover', formData);
  }
};

// ========== 新闻独立表 API ==========
export const newsAPI = {
  getPage: (params) => client.get('/api/news/page', { params }),
  listArticles: (params) => client.get('/api/news/articles', { params }),
  getArticle: (id) => client.get(`/api/news/articles/${id}`),
  createArticle: (data) => client.post('/api/news/articles', data),
  updateArticle: (id, data) => client.put(`/api/news/articles/${id}`, data),
  deleteArticle: (id) => client.delete(`/api/news/articles/${id}`)
};

// ========== List Items API ==========
export const listItemsAPI = {
  getAll: (params) => client.get('/api/list-items', { params }),
  getOne: (id) => client.get(`/api/list-items/${id}`),
  create: (data) => client.post('/api/list-items', data),
  update: (id, data) => client.put(`/api/list-items/${id}`, data),
  delete: (id) => client.delete(`/api/list-items/${id}`)
};

// ========== Auth API ==========
export const authAPI = {
  login: (username, password) => client.post('/api/auth/login', { username, password }),
  changePassword: (old_password, new_password) => client.post('/api/auth/change-password', { old_password, new_password }),
  getCurrentUser: () => client.get('/api/auth/me')
};

export default client;

